<template>
  <NtModal ref="modal" heading="Change Office">
    <p class="mb-6">
      You are currently browsing the {{ hub.short_name }} as
      <strong class="text-black dark:text-white">{{ selectedOffice?.name || 'Office not selected' }}</strong
      >. To see content for another office, please select from the list below.
    </p>
    <NtSelect :options="officeList" v-model="localSelectedOffice" mobile-up list-class="max-h-80" />
  </NtModal>
</template>

<script>
import { useSystemStore } from '@/stores/system'
import { useAuthStore } from '@/stores/auth'
import NtModal from '../general/NtModal.vue'
import { mapActions, mapState } from 'pinia'
import NtSelect from '../forms/NtSelect.vue'

export default {
  components: { NtModal, NtSelect },
  computed: {
    ...mapState(useAuthStore, ['selectedOffice', 'authOffices']),
    ...mapState(useSystemStore, ['hub']),
    officeList() {
      if (this.hub.country_filters_enabled) {
        let countries = this.authOffices.map((o) => o.country)
        countries = countries
          .filter((c, i) => countries.indexOf(c) === i)
          .sort((a, b) => this.$filters.trans('property.country', a) > this.$filters.trans('property.country', b))

        if (countries.length > 1) {
          let output = {}
          for (let c in countries) {
            output[this.$filters.trans('property.country', countries[c])] = this.authOffices
              .filter((o) => o.country === countries[c])
              .sort((a, b) => a.name > b.name)
          }
          return output
        }
      }

      return this.authOffices.map((o) => {
        return { id: o.id, name: o.name }
      })
    },
    localSelectedOffice: {
      get() {
        return this.selectedOffice.id
      },
      set(id) {
        this.switchOffice(id)
      }
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['switchOffice']),
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    }
  },
  watch: {
    selectedOffice() {
      this.$refs.modal.close()
    }
  }
}
</script>
